import { getBackgroundById, getStampById } from './predefinedCardAssets'

export const defaultLogo = '/card/default-logo.png'

export const generateStampsArray = (length, freeLength = 0) => {
  // Handle invalid input
  if (length < 1) return []

  const mainArray = Array.from({ length }, (_, index) => ({
    id: index + 1,
    type: index < Math.ceil(length / 2) ? 'filled' : 'unfilled',
  }))

  // Add free stamps if freeLength > 0
  if (freeLength > 0) {
    const freeStamps = Array.from({ length: freeLength }, (_, index) => ({
      id: length + index + 1, // Continue IDs from where main array ended
      type: 'free',
    }))
    return [...mainArray, ...freeStamps]
  }

  return mainArray
}

export const defaultStampinLogoSettings = {
  visible: true,
  x: 300,
  y: 300,
  width: 70,
  height: 70,
  defaultImage: `${window.location.origin}/CardStampLogo.png`,
}

export const cardTemplates = [
  {
    planLevel: 'enterprise',
    isBlank: true,
    formData: {
      background: {
        type: 'color',
        value: '#ffffff',
      },
      logoSettings: {
        x: 570,
        y: 30,
        width: 100,
        height: 100,
        borderRadius: 0,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 275, // Centered ((700 - 150) / 2)
        y: 250, // Bottom position
        width: 150,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 10,
        y: 270,
      },
      textElements: {
        businessName: {
          text: 'Your Business Name',
          x: 50,
          y: 40,
          fontSize: 36,
          fontFamily: 'Montserrat',
          color: '#1a1a1a',
          fontStyle: 'bold',
        },
        tagline: {
          text: 'Your Tagline Here',
          x: 50,
          y: 90,
          fontSize: 20,
          fontFamily: 'Lato',
          color: '#4a4a11',
          fontStyle: 'italic',
        },
        contactDetails: {
          text: 'Contact Details Here',
          x: 50,
          y: 140,
          fontSize: 16,
          fontFamily: 'Open Sans',
          color: '#666666',
          fontStyle: 'normal',
        },
        offerText: {
          text: 'Tell us about\nyour offer',
          x: 510,
          y: 250,
          fontSize: 24,
          fontFamily: 'Montserrat',
          color: '#2b5c3b',
          fontStyle: 'bold',
        },
        customerId: {
          text: 'CUST-D9461111',
          x: 295, // Centered (same as barcode)
          y: 290, // Just below barcode
          fontSize: 16,
          fontFamily: 'Roboto Mono',
          color: '#000000',
          fontStyle: 'normal',
        },
        progressText: {
          text: '',
          x: 500,
          y: 175,
          fontSize: 28,
          fontFamily: 'Roboto',
          color: '#333333',
          fontStyle: 'normal',
        },
      },
      rewardMechanism: null,
      rewardStyle: null,
      rewardType: null,
      rewardQty: 0,
      threshold: 0,
      progressBarStyles: {
        x: 300,
        y: 175,
        width: 200,
        height: 20,
        borderRadius: 10,
        backgroundColor: '#e5e7eb',
        fillColor: '#3b82f6',
        borderColor: '#d1d5db',
        borderWidth: 1,
        progress: 50,
      },
      stampContainerStyles: {
        x: 300,
        y: 175,
        width: 300,
        height: 100,
        gap: 5,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#2563eb', // Darker blue border
          backgroundColor: '#3b82f6', // Blue background
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#bfdbfe', // Light blue background
        },
        free: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#dbeafe', // Slightly brighter than unfilled
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#2563eb', // Dark blue text
          fontStyle: 'bold',
        },
      },
    },
    stamps: [],
  },

  {
    planLevel: 'basic',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(6),
      },
      logoSettings: {
        x: 581,
        y: 13,
        width: 93,
        height: 93,
        borderRadius: 50,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 520,
        y: 250,
        width: 150,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 400,
        y: 270,
      },
      textElements: {
        businessName: {
          text: 'Propel Fitness',
          fontFamily: 'Montserrat',
          fontSize: 30,
          color: '#1487b8',
          fontStyle: 'bold',
          x: 38,
          y: 22,
        },
        tagline: {
          text: 'Push your limits, find your strength',
          fontFamily: 'Lato',
          fontSize: 20,
          color: '#187775',
          fontStyle: 'italic',
          x: 37,
          y: 59,
        },
        contactDetails: {
          text: '999897564, sudarshan kaloni, jind',
          fontFamily: 'Open Sans',
          fontSize: 16,
          color: '#680321',
          fontStyle: 'normal',
          x: 275,
          y: 32,
        },
        offerText: {
          text: 'Purchase items worth of $5000\n& get 25% discount on next shopping !!!',
          fontFamily: 'Montserrat',
          fontSize: 18,
          color: '#08b1b4',
          fontStyle: 'italic',
          x: 320.0000000000003,
          y: 181.99999999999997,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 14,
          color: '#000000',
          fontStyle: 'normal',
          x: 557,
          y: 302,
        },
        progressText: {
          text: '__%',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },
      rewardMechanism: 'amount_spent',
      rewardStyle: 'progress',
      rewardType: 'discount',
      rewardQty: 25,
      threshold: 5000,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 318,
        y: 114,
        width: 300,
        height: 100,
        gap: 5,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#2563eb', // Darker blue border
          backgroundColor: '#3b82f6', // Blue background
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#bfdbfe', // Light blue background
        },
        free: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#dbeafe', // Slightly brighter than unfilled
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#2563eb', // Dark blue text
          fontStyle: 'bold',
        },
      },
    },
    stamps: [],
  },

  {
    planLevel: 'basic',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(3),
      },
      logoSettings: {
        x: 586,
        y: 8,
        width: 97,
        height: 97,
        borderRadius: 50,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 393,
        y: 37,
        width: 150,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 350,
        y: 270,
      },
      textElements: {
        businessName: {
          text: 'Coffee Haven',
          fontFamily: 'Montserrat',
          fontSize: 33,
          color: '#1a1a1a',
          fontStyle: 'bold',
          x: 49.99999999999999,
          y: 39.999999999999964,
        },
        tagline: {
          text: 'Sip, smile, repeat.',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#2c2c16',
          fontStyle: 'normal',
          x: 50,
          y: 90,
        },
        contactDetails: {
          text: '8907276587, Swarn path, \nMansarover, Jaipur',
          fontFamily: 'Open Sans',
          fontSize: 16,
          color: '#342d2d',
          fontStyle: 'normal',
          x: 50,
          y: 140,
        },
        offerText: {
          text: 'Spend $100 \n          &    \n  Get 50 reward points ',
          fontFamily: 'Open Sans',
          fontSize: 24,
          color: '#48514b',
          fontStyle: 'bold italic',
          x: 53,
          y: 251,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 14,
          color: '#000000',
          fontStyle: 'normal',
          x: 394,
          y: 86,
        },
        progressText: {
          text: '__%',
          fontFamily: 'Roboto',
          fontSize: 28,
          color: '#222020',
          fontStyle: 'normal',
          x: 364,
          y: 211,
        },
      },
      rewardMechanism: 'amount_spent',
      rewardStyle: 'progress',
      rewardType: 'points',
      rewardQty: 50,
      threshold: 100,
      progressBarStyles: {
        x: 53.22060286801289,
        y: 206.22964669738886,
        width: 298,
        height: 28,
        borderRadius: 20,
        backgroundColor: '#ffffff',
        fillColor: '#cc7e3e',
        borderColor: '#ffffff',
        borderWidth: 0,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 318,
        y: 114,
        width: 300,
        height: 100,
        gap: 5,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#2563eb', // Darker blue border
          backgroundColor: '#3b82f6', // Blue background
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#bfdbfe', // Light blue background
        },
        free: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#dbeafe', // Slightly brighter than unfilled
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#2563eb', // Dark blue text
          fontStyle: 'bold',
        },
      },
    },
    stamps: [],
  },

  // main template with stamps and progress bar
  {
    planLevel: 'premium',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(1),
      },
      logoSettings: {
        x: 480,
        y: 10,
        width: 80,
        height: 80,
        borderRadius: 50,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 19,
        y: 291,
        width: 139,
        height: 26,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 20,
        y: 135,
      },
      textElements: {
        businessName: {
          text: 'Paper Empire',
          fontFamily: 'Montserrat',
          fontSize: 34,
          color: '#d85555',
          fontStyle: 'bold',
          x: 17,
          y: 15,
        },
        tagline: {
          text: 'Make paper feel special',
          fontFamily: 'Lato',
          fontSize: 20,
          color: '#4a4a11',
          fontStyle: 'italic',
          x: 19,
          y: 50,
        },
        contactDetails: {
          text: 'Business Phone no.\nJaipur, Rajasthan',
          fontFamily: 'Arial',
          fontSize: 16,
          color: '#ad1a1a',
          fontStyle: 'italic',
          x: 20,
          y: 83,
        },
        offerText: {
          text: 'Buy 8 Pencil Boxes\nGet another 2 free',
          fontFamily: 'Montserrat',
          fontSize: 27,
          color: '#ffc800',
          fontStyle: 'bold',
          x: 17,
          y: 221,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 17,
          color: '#000000',
          fontStyle: 'normal',
          x: 17,
          y: 323,
        },
        progressText: {
          text: '',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },
      rewardMechanism: 'quantity_purchased',
      rewardStyle: 'stamps',
      rewardType: 'free-item',
      rewardQty: 2,
      threshold: 8,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 178,
        y: 93,
        width: 300,
        height: 100,
        gap: 5,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#ffd500',
          backgroundColor: '#ffe1ad',
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#ffffff',
          backgroundColor: '#ffffff',
        },
        free: {
          borderWidth: 2,
          borderColor: '#ffffff',
          backgroundColor: '#ffffff',
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#ffe1ad',
          fontStyle: 'bold',
        },
      },
      stamps: generateStampsArray(8, 2),
    },
  },

  {
    planLevel: 'premium',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(4),
      },
      logoSettings: {
        x: 585,
        y: 10,
        width: 90,
        height: 90,
        borderRadius: 48,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 525,
        y: 267,
        width: 150,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 410,
        y: 270,
      },
      textElements: {
        businessName: {
          text: 'Sparkle Shine Auto Detailing',
          fontFamily: 'Montserrat',
          fontSize: 36,
          color: '#1a1a1a',
          fontStyle: 'bold',
          x: 21,
          y: 20,
        },
        tagline: {
          text: 'Get Your Ride Cool and Clean.\n',
          fontFamily: 'Lato',
          fontSize: 20,
          color: '#176d26',
          fontStyle: 'italic',
          x: 23,
          y: 63,
        },
        contactDetails: {
          text: '1-1324343434, 31-street\nLA , USA',
          fontFamily: 'Open Sans',
          fontSize: 16,
          color: '#2d5228',
          fontStyle: 'normal',
          x: 456,
          y: 184,
        },
        offerText: {
          text: 'Visit 4 times & get 1 \nservice absolutely \nfree !!!',
          fontFamily: 'Montserrat',
          fontSize: 20,
          color: '#2b5c3b',
          fontStyle: 'bold',
          x: 456,
          y: 111,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 13,
          color: '#000000',
          fontStyle: 'normal',
          x: 557,
          y: 316,
        },
        progressText: {
          text: '',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },

      rewardMechanism: 'quantity_purchased',
      rewardStyle: 'stamps',
      rewardType: 'free-item',
      rewardQty: 1,
      threshold: 4,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 117,
        y: 106,
        width: 300,
        height: 100,
        gap: 5,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#4a5568',
          backgroundColor: '#3b82f6',
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#4a5568',
          backgroundColor: '#ffffff',
        },
        free: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#dbeafe', // Slightly brighter than unfilled
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#2563eb', // Dark blue text
          fontStyle: 'bold',
        },
      },
      stamps: generateStampsArray(4, 1),
    },
  },

  {
    planLevel: 'premium',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(7),
      },
      logoSettings: {
        x: 457,
        y: 219,
        width: 71,
        height: 71,
        borderRadius: 45,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 412,
        y: 153,
        width: 150,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 620,
        y: 200,
      },
      textElements: {
        businessName: {
          text: 'The pet hub',
          fontFamily: 'Montserrat',
          fontSize: 36,
          color: '#3e0404',
          fontStyle: 'bold',
          x: 50,
          y: 40,
        },
        tagline: {
          text: 'Your Pets Deserve The Best',
          fontFamily: 'Lato',
          fontSize: 20,
          color: '#630303',
          fontStyle: 'italic',
          x: 58,
          y: 77,
        },
        contactDetails: {
          text: '7869875643,adarsh nagar,rewari',
          fontFamily: 'Open Sans',
          fontSize: 16,
          color: '#b81a0f',
          fontStyle: 'normal',
          x: 181,
          y: 286,
        },
        offerText: {
          text: 'Make 10 times , and get \n20 points in your card!',
          fontFamily: 'Montserrat',
          fontSize: 24,
          color: '#925611',
          fontStyle: 'bold',
          x: 348,
          y: 68,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 13,
          color: '#000000',
          fontStyle: 'normal',
          x: 579.9999999999972,
          y: 167,
        },
        progressText: {
          text: '',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },
      rewardMechanism: 'quantity_purchased',
      rewardStyle: 'stamps',
      rewardType: 'points',
      rewardQty: 20,
      threshold: 10,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 16,
        y: 123,
        width: 300,
        height: 100,
        gap: 15,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#4a5568',
          backgroundColor: '#e2a765',
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#4a5568',
          backgroundColor: '#f8e2ce',
        },
        free: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#dbeafe', // Slightly brighter than unfilled
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#2563eb', // Dark blue text
          fontStyle: 'bold',
        },
      },
      stamps: generateStampsArray(10),
    },
  },

  {
    planLevel: 'premium',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(8),
      },
      logoSettings: {
        x: 570,
        y: 30,
        width: 76,
        height: 76,
        borderRadius: 0,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 165,
        y: 187,
        width: 150,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 620,
        y: 270,
      },
      textElements: {
        businessName: {
          text: 'Royal Care Pharmacy',
          fontFamily: 'Montserrat',
          fontSize: 36,
          color: '#1a1a1a',
          fontStyle: 'bold',
          x: 50,
          y: 40,
        },
        tagline: {
          text: 'Your Health, Our Priority',
          fontFamily: 'Lato',
          fontSize: 20,
          color: '#4a4a11',
          fontStyle: 'italic',
          x: 50,
          y: 90,
        },
        contactDetails: {
          text: 'Free health screenings\nwellness exams and \nblood pressure checks',
          fontFamily: 'Open Sans',
          fontSize: 16,
          color: '#43564b',
          fontStyle: 'normal',
          x: 50,
          y: 120,
        },
        offerText: {
          text: 'Visit 5 times & \nGet 20% discount  ',
          fontFamily: 'Montserrat',
          fontSize: 24,
          color: '#2b5c3b',
          fontStyle: 'bold',
          x: 388,
          y: 159,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 14,
          color: '#000000',
          fontStyle: 'normal',
          x: 192,
          y: 238,
        },
        progressText: {
          text: '',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },
      rewardMechanism: 'number_of_visits',
      rewardStyle: 'stamps',
      rewardType: 'discount',
      rewardQty: 20,
      threshold: 5,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 177,
        y: 272,
        width: 300,
        height: 100,
        gap: 10,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#2fa799',
          backgroundColor: '#2bd7ee',
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#65a48f',
          backgroundColor: '#3bf7d8',
        },
        free: {
          borderWidth: 2,
          borderColor: '#3b82f6', // Blue border
          backgroundColor: '#dbeafe', // Slightly brighter than unfilled
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#2563eb', // Dark blue text
          fontStyle: 'bold',
        },
      },
      stamps: generateStampsArray(5),
    },
  },

  {
    planLevel: 'premium',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(31),
      },
      logoSettings: {
        x: 565,
        y: 13,
        width: 100,
        height: 100,
        borderRadius: 0,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 33.99999999999997,
        y: 273.99999999999994,
        width: 150,
        height: 48,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 5,
        y: 5,
      },
      textElements: {
        businessName: {
          text: 'Salon Divine',
          fontFamily: 'Montserrat',
          fontSize: 34,
          color: '#1a1a1a',
          fontStyle: 'bold',
          x: 209.99999999999997,
          y: 25.999999999999982,
        },
        tagline: {
          text: 'Style your story',
          fontFamily: 'Open Sans',
          fontSize: 19,
          color: '#0a0a0a',
          fontStyle: 'normal',
          x: 213,
          y: 63,
        },
        contactDetails: {
          text: '8978654321, Second floor Bajrang bhawan,\n Atish market, Indore',
          fontFamily: 'Open Sans',
          fontSize: 16,
          color: '#0a0a0a',
          fontStyle: 'bold',
          x: 270,
          y: 277,
        },
        offerText: {
          text: 'Visit 5 times \n& \nGet 25% discount  ',
          fontFamily: 'Montserrat',
          fontSize: 24,
          color: '#2b586e',
          fontStyle: 'bold',
          x: 231,
          y: 120,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 16,
          color: '#000000',
          fontStyle: 'normal',
          x: 53,
          y: 328,
        },
        progressText: {
          text: '',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },
      rewardMechanism: 'number_of_visits',
      rewardStyle: 'stamps',
      rewardType: 'discount',
      rewardQty: 0,
      threshold: 5,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 223,
        y: 198,
        width: 300,
        height: 100,
        gap: 10,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#1454c2',
          backgroundColor: '#4fa6e8',
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#0f71cc',
          backgroundColor: '#3765ae',
        },
        free: {
          borderWidth: 2,
          borderColor: '#ffffff',
          backgroundColor: '#ffffff',
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#ffe1ad',
          fontStyle: 'bold',
        },
      },
      stamps: generateStampsArray(5),
    },
  },
  {
    planLevel: 'premium',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(9),
      },
      logoSettings: {
        x: 237.99999999999991,
        y: 281.0000000000002,
        width: 68,
        height: 56,
        borderRadius: 0,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 354,
        y: 30,
        width: 150,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 620,
        y: 270,
      },
      textElements: {
        businessName: {
          text: 'Burger Bliss',
          fontFamily: 'Montserrat',
          fontSize: 36,
          color: '#1a1a1a',
          fontStyle: 'bold',
          x: 50,
          y: 40,
        },
        tagline: {
          text: 'Where every bite tells a story',
          fontFamily: 'Lato',
          fontSize: 20,
          color: '#4a4a11',
          fontStyle: 'italic',
          x: 50,
          y: 90,
        },
        contactDetails: {
          text: '9127658756,chawla marg,\nvasant vihar , West Delhi',
          fontFamily: 'Open Sans',
          fontSize: 16,
          color: '#2a4b26',
          fontStyle: 'normal',
          x: 336,
          y: 303,
        },
        offerText: {
          text: 'Get Two Burgers free \n on completing 10 orders',
          fontFamily: 'Montserrat',
          fontSize: 20,
          color: '#2b5c3b',
          fontStyle: 'bold',
          x: 348,
          y: 163,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 14,
          color: '#000000',
          fontStyle: 'normal',
          x: 369,
          y: 84,
        },
        progressText: {
          text: '',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },
      rewardMechanism: 'quantity_purchased',
      rewardStyle: 'stamps',
      rewardType: 'free-item',
      rewardQty: 2,
      threshold: 10,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 20,
        y: 141,
        width: 300,
        height: 100,
        gap: 5,
        stampsPerRow: 6,
      },
      stampStyles: {
        filled: {
          borderWidth: 2,
          borderColor: '#4a5568',
          backgroundColor: '#16c2c5',
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 2,
          borderColor: '#54b6b4',
          backgroundColor: '#3bf4f7',
        },
        free: {
          borderWidth: 2,
          borderColor: '#54b6b4',
          backgroundColor: '#3bf4f7',
          text: 'FREE',
          fontSize: 14,
          fontFamily: 'Montserrat',
          color: '#000000',
          fontStyle: 'bold',
        },
      },
      stamps: generateStampsArray(10, 2),
    },
  },
  {
    planLevel: 'premium',
    formData: {
      background: {
        type: 'image',
        value: getBackgroundById(13),
      },
      logoSettings: {
        x: 30.99999999999999,
        y: 247.99999999999997,
        width: 91,
        height: 90,
        borderRadius: 50,
        image: defaultLogo,
      },
      barcodeSettings: {
        x: 512,
        y: 59.000000000000014,
        width: 167,
        height: 40,
        color: '#000000',
        bgColor: '#ffffff',
      },
      stampinLogoSettings: {
        ...defaultStampinLogoSettings,
        x: 390,
        y: 150,
      },
      textElements: {
        businessName: {
          text: 'The Washery',
          fontFamily: 'Montserrat',
          fontSize: 36,
          color: '#1a1a1a',
          fontStyle: 'bold',
          x: 34,
          y: 24,
        },
        tagline: {
          text: 'A Clean Start for Your Wardrobe',
          fontFamily: 'Lato',
          fontSize: 20,
          color: '#4a4a11',
          fontStyle: 'italic',
          x: 41,
          y: 68,
        },
        contactDetails: {
          text: '7865453421, Sec-42, near bada park, \nNoida',
          fontFamily: 'Open Sans',
          fontSize: 18,
          color: '#3a4b3f',
          fontStyle: 'normal',
          x: 381,
          y: 15,
        },
        offerText: {
          text: '10% Discount on \n every 11th visit !',
          fontFamily: 'Montserrat',
          fontSize: 24,
          color: '#2b5c3b',
          fontStyle: 'bold',
          x: 137,
          y: 268,
        },
        customerId: {
          text: 'CUST-D9461111',
          fontFamily: 'Roboto Mono',
          fontSize: 16,
          color: '#000000',
          fontStyle: 'normal',
          x: 571,
          y: 104,
        },
        progressText: {
          text: '',
          fontFamily: 'Roboto',
          fontSize: 20,
          color: '#1a18af',
          fontStyle: 'normal',
          x: 583,
          y: 133,
        },
      },
      rewardMechanism: 'quantity_purchased',
      rewardStyle: 'stamps',
      rewardType: 'discount',
      rewardQty: 20,
      threshold: 10,
      progressBarStyles: {
        x: 279,
        y: 120,
        width: 289,
        height: 37,
        borderRadius: 20,
        backgroundColor: '#cddaf4',
        fillColor: '#6d97d9',
        borderColor: '#6f9fe7',
        borderWidth: 4,
        progress: 50,
        draggable: true,
        resizable: true,
      },
      stampContainerStyles: {
        x: 37,
        y: 107,
        width: 300,
        height: 100,
        gap: 12,
        stampsPerRow: 5,
      },
      stampStyles: {
        filled: {
          borderWidth: 3,
          borderColor: '#0a0a0b',
          backgroundColor: '#36d97c',
          image: getStampById(0),
        },
        unfilled: {
          borderWidth: 3,
          borderColor: '#3b723b',
          backgroundColor: '#7ac79f',
        },
        free: {
          borderWidth: 2,
          borderColor: '#ffffff',
          backgroundColor: '#ffffff',
          text: 'FREE',
          fontSize: 18,
          fontFamily: 'Montserrat',
          color: '#ffe1ad',
          fontStyle: 'bold',
        },
      },
      stamps: generateStampsArray(8),
    },
  },
]

export const getPlanTemplates = (plan) => {
  const planLevels = {
    basic: ['basic'],
    premium: ['basic', 'premium'],
    enterprise: ['basic', 'premium', 'enterprise'],
  }

  const allowedLevels = planLevels[plan] || ['basic']
  return cardTemplates.filter((template) => allowedLevels.includes(template.planLevel))
}
